<template>

    <v-data-table
      :headers="headers"
      :items="automodules"
      :loading="isLoading"
      hide-default-footer
      loading-text="general.loading"
      density="compact"
      :sort-by="[{ key: 'date_from', order: 'desc' }]"
      :items-per-page="-1"
      striped="even"
      hover
    >

      <template v-slot:[`header.close`]>
        <v-icon color="red" size="x-large">mdi-lock</v-icon>
      </template>

      <template v-slot:[`item.date_there`]="{ item }">
        {{ $formatDate(item.date_there) }}
      </template>

      <template v-slot:[`item.event_name`]="{ item }">
        <router-link :to="'/soutez/' + item.event_id">{{ item.event_name }}</router-link> 
      </template>

      <template v-slot:[`item.export`]="{ item }">
        <a :href="`${BaseUrl}/automodule/?automodule_id=${item.automodule_id}`" target="_blank">
          <v-icon color="green" size="30">mdi-microsoft-excel</v-icon>
        </a>
      </template>

      <template v-slot:[`item.driver`]="{ item }">
        <span style="white-space: nowrap">{{ item.driver }}</span>
      </template>

      <template v-slot:[`item.entries_sum`]="{ item }">
        <span style="white-space: nowrap">{{ item.entries_sum }} / {{ item.max_entries }}</span>
      </template>

      <template v-slot:[`item.sum_km`]="{ item }">
        <span style="white-space: nowrap">{{ item.sum_km }} km</span>
      </template>


      <template v-slot:[`item.payment`]="{ item }">
        <span style="white-space: nowrap">{{  Number(item.payment).toLocaleString('cs-CZ') }} {{currencySymbol(props.eventCurrency) }}</span>
      </template>

      <template v-slot:[`item.close`]="{ item }">
        <div class="d-flex justify-center align-center">
          <v-checkbox
            density="compact"
            hide-details
            class="ma-0 pa-0" 
            :model-value="item.close"
            @update:model-value="(val) => submitCloseAutomodule(item.automodule_id, val)"
          />
        </div>
      </template>



    </v-data-table>
    <v-col cols="12" md="2">
      <SelectYear v-model="selectedYear" />

    </v-col>  

</template>





<script setup>

import { ref, computed, watch } from 'vue';
// import {useSnackbarStore} from '@/stores/snackbarStore'
import apiClient from '/api.js';
import { useRoute } from 'vue-router';
import SelectYear from '@/components/shared/SelectYear.vue';
import {useSnackbarStore} from '@/stores/snackbarStore'
import { useI18n } from 'vue-i18n'
import { currencySymbol } from '@/components/const/enums.js';



const props = defineProps({
  activeTab: {
    type: String,
    required: true,
  },
  eventCurrency: {
    type: String,
    default: currencySymbol.CZK
  }

});

const { t } = useI18n();

// Vypočítáme, zda je aktivní záložka club_payments
const isTabActive = computed(() => props.activeTab === 'automodules');

// const snackbar = useSnackbarStore()
const route = useRoute();


// const errorMessage = ref('');


const club_shortcut = computed(() => route.params.id)
const BaseUrl = ref(process.env.VUE_APP_API_BASE_URL);
const snackbar = useSnackbarStore()


const isLoading = ref(false);
const automodules = ref([]);
const selectedYear = ref(new Date().getFullYear()); // Výchozí rok je aktuální rok

const fetchAutomodules = async () => {
  isLoading.value = true;
  try {
    const response = await apiClient.get(`/automodule/?club_shortcut=${club_shortcut.value}&year=${selectedYear.value}`);
    automodules.value = response.data;
  } catch (error) {
    console.error(error);
  } finally {
    isLoading.value = false;
  }
};


// Definice hlaviček tabulky
const headers = [
  { title: t('club.club_automodules.date'), value: 'date_there' },
  { title: t('club.club_automodules.event'), value: 'event_name', minWidth:170 },
  { title: '', value: 'export', width: 50 },
  { title: t('club.club_automodules.driver'), value: 'driver' },
  { title: t('club.club_automodules.seats'), value: 'entries_sum' },
  { title: t('club.club_automodules.distance'), value: 'sum_km' },
  { title: t('club.club_automodules.amount'), value: 'payment' },
  { title: '', value: 'close', width: 50 },

];



// Sledujeme změnu aktivní záložky
watch(isTabActive, (newVal) => {
  if (newVal) {
    fetchAutomodules();
  }
}, { immediate: true });


// Pokud se změní vybraný rok, opět načteme data (pokud je záložka aktivní)
watch(selectedYear, () => {
  if (isTabActive.value) {
    fetchAutomodules();
  }
});



const submitCloseAutomodule = async (automodule_id, close) => {
  try {
    await apiClient.put(`/automodule/?automodule_id=${automodule_id}`, {
      close,
    });
    snackbar.success(t('club.club_automodules.updated'))
    fetchAutomodules();

  } catch (err) {
    console.error(err);
    snackbar.error(t('club.club_automodules.error'));
  }
};



</script>

<style scoped>



</style>